import React, { Component } from 'react';

import "./FormHeader.scss"

class FormHeader extends Component {
  constructor(props) {
    super();
    this.state = {

    }
  }
  render() {
    return (
      <section className="section section-header">
        <div className="formheader">
        { /* <h2 dangerouslySetInnerHTML={{__html: this.props.data.headline}}></h2> */ }
        { /* <div className="poalim"></div> */ }
        <div className="dilemma"></div>
        <h3 dangerouslySetInnerHTML={{__html: this.props.data.desc}}></h3>
        </div>
      </section>
    );
  }
}

export default FormHeader;



// WEBPACK FOOTER //
// ./src/Components/FormBody/FormHeader.js